import type { Performance, Segment } from "./types";

/**
 * 手元で見た歌唱の控え（このタブのあいだだけ。端末には残さない）。
 *
 * 契約の MomentView は「区間の版の ID」しか持たず、どの曲のここ好きかを API から引けない（★ docs/API_NEEDS.md）。
 * 再生中の曲・キュー・一覧などで一度見た歌唱を覚えておき、ここ好きの曲名を出すのに使う。
 * 覚えていなければ「曲の情報を取得できない」と正直に出す（推測で別の曲を出さない）。
 */
const byPerformance = new Map<string, Performance>();
const bySegment = new Map<string, { performanceId: string; segment: Segment }>();

export function remember(p: Performance | null | undefined): void {
  if (!p) return;
  byPerformance.set(p.id, p);
  bySegment.set(p.segment.id, { performanceId: p.id, segment: p.segment });
}

export function rememberSegment(performanceId: string, segment: Segment): void {
  bySegment.set(segment.id, { performanceId, segment });
}

export function performanceForSegment(segmentId: string): { performance: Performance; segment: Segment } | null {
  const hit = bySegment.get(segmentId);
  if (!hit) return null;
  const performance = byPerformance.get(hit.performanceId);
  return performance ? { performance, segment: hit.segment } : null;
}

export function cachedPerformance(id: string): Performance | undefined {
  return byPerformance.get(id);
}

/** テスト用 */
export function clearPerformanceCache(): void {
  byPerformance.clear();
  bySegment.clear();
}
